function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "customer",
  transform: "translate(0.938 -1.627)"
}, React.createElement("rect", {
  id: "Rectangle_3537",
  "data-name": "Rectangle 3537",
  width: 18,
  height: 18,
  transform: "translate(-0.938 1.627)",
  fill: "none"
}), React.createElement("g", {
  id: "Group_3642",
  "data-name": "Group 3642",
  transform: "translate(-2.938 -0.373)"
}, React.createElement("path", {
  id: "Path_12764",
  "data-name": "Path 12764",
  d: "M16.2,14.061H1.8a1.8,1.8,0,0,1-1.8-1.8V1.8A1.8,1.8,0,0,1,1.8,0H16.2A1.8,1.8,0,0,1,18,1.8V12.261a1.8,1.8,0,0,1-1.8,1.8M5.565,6.75a2.446,2.446,0,0,0-1.452.482c-.77.616-.752,1.431-.731,2.375,0,.161.007.327.007.5a.575.575,0,0,0,.572.573c.675,0,1.228,0,1.671.008h.788c1.1,0,1.2-.049,1.338-.354.051-.118.051-.118.049-.776v-.8A1.973,1.973,0,0,0,5.99,6.784a2.489,2.489,0,0,0-.425-.034M10.48,9.656a.5.5,0,0,0,0,1h2.5a.5.5,0,0,0,0-1Zm0-3.124a.5.5,0,1,0-.042,1h3.54a.5.5,0,0,0,.042-1H10.48ZM5.6,3.374A1.424,1.424,0,1,0,7.02,4.8v0A1.427,1.427,0,0,0,5.6,3.374m4.881.032a.5.5,0,0,0,0,1h2.5a.5.5,0,0,0,0-1Z",
  transform: "translate(2 4)",
  fill: "#fff"
})));

var SvgCustomer = function SvgCustomer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCustomer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customer.c86a6917.svg";
export { ForwardRef as ReactComponent };